import React from 'react'
import styles from '../styles/aboutcomponent.module.css';
import One_movie_one_book from '../../../assets/about/projects/one_book_one_movie.jpg';
import Inspirational_visit from '../../../assets/about/projects/inspirational-visit-300x216.jpg';
import Art_and_craft_1 from '../../../assets/about/projects/art-300x216.jpg';
import Educational_tour from '../../../assets/about/projects/educational-tour-300x225.jpg';
import Circle_ringan from '../../../assets/about/Ringan-300x216.jpg';
import Skill_Dev from '../../../assets/about/projects/skill-development-300x216.jpg';
import Live_eat_together from '../../../assets/about/projects/dinner-300x168.jpg';
import Music_live from '../../../assets/about/projects/music-300x216.jpg';
import yoga from '../../../assets/about/projects/yoga-480x360.jpeg';
import For_the_children_by_the_children from '../../../assets/about/projects/image_046.jpeg';
import Eco_friendly from '../../../assets/about/projects/image_060.jpeg';
import Eco_Ganpati from '../../../assets/about/projects/image_061.jpeg';
const WhatWeDo = () => {
  return (
    <div className={styles.about_component}>
            {/* ================= WHAT WE DO ================= */}
        <div id="what-we-do" className={styles.sectionAnchor}>
          <h2>WHAT WE DO: Life at Snehwan</h2>

          <div className={styles.about_container}>
            <div>
              <h4>Live Together, Eat Together</h4>
              <p>
                We don't operate an institution; we run a home. Ashok,
                Archana, and all the children gather daily to share meals,
                fostering a sense of community, love, and belonging.
              </p>
            </div>
            <div>
              <img src={Live_eat_together} alt="Live together, eat together" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>For the Children, By the Children (Student-Led Governance): </h4>
              <p>
                 We don't just teach leadership; we practice it. Snehwan instils vital responsibility by actively putting children in charge of the institute’s daily operations. From managing the kitchen and finance to overseeing the library, each child holds age-specific leadership roles. When an 8th grader manages the IT Lab and a 9th grader runs the library, they aren't just doing chores—they are learning autonomy, accountability, and the power of peer-to-peer mentorship. 
              </p>
            </div>
            <div>
              <img src={For_the_children_by_the_children} alt="For the children, by the children" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Teaching Social Responsibility</h4>
              <p>
                During harsh winters, our students distribute warm blankets to
                local sugarcane workers and dedicate time to teaching their
                children — learning empathy and the joy of selfless giving.
              </p>
            </div>
            <div>
              <img src={Skill_Dev} alt="Teaching social responsibility" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>One Book, One Movie!</h4>
              <p>
                Every weekend, we screen an educational film — but the ticket
                to entry is completing a book from our 15,000-book library.
                This has skyrocketed reading habits and inspired many children
                to keep diaries and write poems.
              </p>
            </div>
            <div>
              <img src={One_movie_one_book} alt="One Book, One Movie" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Ringan (The Circle of Confidence)</h4>
              <p>
                All children sit in a circle of equals. Each child gets a
                safe platform to stand and speak for two minutes — reviewing a
                book or sharing a spontaneous opinion — dramatically boosting
                confidence and articulation.
              </p>
            </div>
            <div>
              <img src={Circle_ringan} alt="Ringan circle" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Inspirational Talks</h4>
              <p>
                Through engaging conversations with successful individuals
                from diverse backgrounds, our children learn the
                transformative power of grit and perseverance, and that no
                obstacle is too great with hard work and commitment.
              </p>
            </div>
            <div>
              <img src={Inspirational_visit} alt="Inspirational talks" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Educational Tours</h4>
              <p>
                We broaden our children's horizons through immersive tours of
                colleges, industries, small businesses, and historic forts —
                bridging textbook theory and practical reality.
              </p>
            </div>
            <div>
              <img src={Educational_tour} alt="Educational tour" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Physical &amp; Mental Well-being</h4>
              <p>
                Mallakhamb (traditional vertical pole gymnastics), daily
                Suryanamaskar, yoga, and breathwork nurture inner calm,
                strength, and holistic health.
              </p>
            </div>
            <div>
              <img src={yoga} alt="Yoga and Mallakhamb" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Lessons in Music</h4>
              <p>
                Ashok's father and dedicated teachers give music lessons —
                vocal training and instrumental lessons in tabla and harmonium
                — instilling discipline and a sense of pride in cultural
                heritage.
              </p>
            </div>
            <div>
              <img src={Music_live} alt="Music lessons" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Art &amp; Craft (Hands-On Mindfulness)</h4>
              <p>
                Thread greeting, collage making, and intricate handicrafts
                make learning joyful while demanding neatness, accuracy, and
                focus — supporting cognitive development and creativity.
              </p>
            </div>
            <div>
              <img src={Art_and_craft_1} alt="Art and craft" loading="lazy" />
            </div>
          </div>

          <div className={styles.about_container}>
            <div>
              <h4>Eco-Friendly Living</h4>
              <p>
                Snehwan runs entirely on green energy — 100% of our
                electricity is generated on-site by our Solar Power Station,
                while our Biogas Generation Plant produces over 5,000 liters
                of gas daily to fuel our community kitchen.
              </p>
            </div>
            <div>
              <img src={Eco_friendly} alt="Eco-friendly living" loading="lazy" />
               <img src={Eco_Ganpati} alt="Eco-friendly living" loading="lazy" />
            </div>
          
          </div>
        </div>
    </div>
  )
}

export default WhatWeDo